<template>
  <div class="rws-erp-project-offer-info">
    <div class="content-wrapper" v-if="loaded">
      <basic-info-card :basicInfo="basicInfo" :canEdit="canEdit" v-on:edit="openEditModal" class="card" />
      <a-card title="项目组成员" :bordered="false">
        <div slot="extra">
          <a style="margin-right:24px;" icon="plus" type="primary" class="add-member" v-if="canEdit && quoteBasicInfo.can_change_staff_manager" @click="handModuleOver">分配模块负责人</a>
          <a style="margin-right:24px;" icon="plus" type="primary" class="add-member" v-if="canEdit && quoteBasicInfo.can_handover" @click="handOver">模块负责人交接</a>
          <a-popover placement="bottomRight">
            <template slot="content">
              <p class="extra-content" @click="openAddMemberModalByName">通过姓名添加</p>
              <!-- <p class="extra-content" @click="openAddMemberModal">通过角色添加</p>-->
              <p class="extra-content" v-if="quoteBasicInfo.can_add_members_by_dept" @click="openAddDeptModal">通过部门添加</p>
            </template>
            <a icon="plus" type="primary" class="add-member" v-if="canEdit && quoteBasicInfo.can_add_members" :disabled="disableAddMember || disableAddMemberByName">+添加成员</a>
          </a-popover>
        </div>
        <a-table :columns="tableData.columns" :dataSource="tableData.dataSource" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :loading="tableData.loading" :pagination="false" :rowKey="record => record.staff_uid" :scroll="{x:1300,y:500}">
          <span slot="operation" slot-scope="text, record, index">
            <a-popconfirm class="confirm" placement="topRight" okText="确定" cancelText="取消" @confirm="confirm(record)">
              <template slot="title">
                <p>确定{{authOperation(record.auth_status)}}吗? </p>
              </template>
              <a v-if="record.auth_status && record.can_auth && canEdit">{{authOperation(record.auth_status)}}</a>
            </a-popconfirm>
          </span>
        </a-table>
      </a-card>
    </div>
    <div v-else class="loading-spin">
      <a-spin></a-spin>
    </div>

    <add-member-modal-by-name :memberData="memberDataByName" @submit="submitAddMemberByName" @searchMemberList="getEmployeesTreeByName" :loading="loading" ref="addMemberModalByName" />
    <add-member-modal :memberData="memberData" @submit="submitAddMember" @changeMemberList="getEmployeesTree" ref="addMemberModal" />
    <AddMemberByDeptModal v-model="deptModal" @submit="submitAddMember" :projectId='param.project_id'/>

    <new-project-modal @cancel="closeNewProjectModal" :modal-type="modalType" :can_edit_revenue_method="can_edit_revenue_method" :basicInfo="quoteBasicInfo" :visible="modalVisible" v-if="modalVisible" :options="projectSelects" ref="newProject" :submitLoading="submitLoading" @submit="submitEditInfo" :defaultData="basicInfoEdit" />
    <a-modal title="负责人交接" :visible="handoverModalShow" @ok="handleOk" @cancel="handleCancel" :width="400">
      <a-form :form="handoverForm">
        <a-form-item label="交接人" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-select v-decorator="['handover_uid']" placeholder="请选择交接人" :allowClear="true" showSearch :filterOption="filterOption">
            <a-select-option :value="item.key" v-for="(item,index) in handoverList" :key="index">
              {{item.val}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="承接人" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-select v-decorator="['acceptance_uid']" placeholder="请选择承接人" :allowClear="true" showSearch :filterOption="filterOption">
            <a-select-option :value="item.key" v-for="(item,index) in acceptanceList" :key="index">
              {{item.val}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="分配模块负责人" :visible="moduleModalShow" @ok="handlemoduleModalOk" @cancel="handleCancel" :width="400">
      <a-form :form="moduleModalForm">
        <a-form-item label="负责人" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-select v-decorator="['manager_uid']" placeholder="请选择模块负责人" :allowClear="true" showSearch :filterOption="filterOption">
            <a-select-option :value="item.id" v-for="item in basicInfo.values.editor_uids" :key="item.id">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import ProjectManageService from '../../services/ProjectManageService.js';
import NewProjectModal from './NewProjectModal';
import AddMemberByDeptModal from '../../components/projectManage/AddMemberByDeptModal.vue';

export default {
  components: {
    NewProjectModal, AddMemberByDeptModal
  },

  props: {
    basicInfo: {
      type: Object,
      default: () => ({
        canEdit: null,
        values: {}
      })
    },
    canEdit: Boolean,
    quoteBasicInfo: Object,
    basicInfoEdit: Object,
    param: Object,
    can_edit_revenue_method: Boolean
  },

  data() {
    return {
      deptModal: false,
      breadcrumb: [
        {
          label: '项目管理'
        },
        {
          label: '项目信息',
          path: {
            name: 'projectManage.projectInfoList'
          }
        },
        {
          label: '项目详情'
        }
      ],
      handoverModalShow: false,
      moduleModalShow: false,
      handoverForm: this.$form.createForm(this),
      moduleModalForm: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          sm: { span: 3 }
        },
        wrapperCol: {
          sm: { span: 5 }
        }
      },
      handoverList: [],
      acceptanceList: [],
      moduleList: [], // 模块负责人
      tableData: {
        columns: [
          {
            title: '部门',
            dataIndex: 'department',
            width: 120
          },
          {
            title: '团队',
            dataIndex: 'team',
            width: 120
          },
          // {
          //   title: '角色',
          //   dataIndex: 'execrole_code_name',
          //   width: 130
          // },
          {
            title: '岗位',
            dataIndex: 'title',
            width: 80
          },
          {
            title: '姓名',
            dataIndex: 'staff_name',
            width: 100
          },
          {
            title: '状态',
            dataIndex: 'auth_status',
            width: 100
          },
          {
            title: '授权开始日期',
            dataIndex: 'attach_time',
            width: 150
          },
          {
            title: '授权结束日期',
            dataIndex: 'detach_time',
            // width: 150
          },
          {
            title: '模块负责人',
            dataIndex: 'auth_staff_name',
            width: 100
          },
          {
            title: '修改时间',
            dataIndex: 'update_time',
            width: 150,
          },
          {
            title: '操作',
            dataIndex: 'operation',
            fixed: 'right',
            width: 100,
            scopedSlots: { customRender: 'operation' }
          }
        ],
        dataSource: [],
        loading: false
      },
      memberData: {
        visible: false,
        roleList: [],
        employeeList: []
      },
      memberDataByName: {
        visible: false,
        roleList: [],
        employeeList: [],
        defaultRoleList: [],
      },
      projectSelects: {
        project_sn_list: [],
        business_unit_map: [],
        profit_center_map: [],
        project_type_map: [],
        project_progress_map: [],
        bidding_type_map: [],
        therapy_area_map: [],
        researcher_product_map: [],
        manager_map: []
      },

      loaded: false,
      disableAddMember: false,
      disableAddMemberByName: false,
      modalType: 'edit',
      modalVisible: false,
      loading: false,
      selectedRowKeys: [],
      submitLoading: false,
    };
  },

  created() {
    Promise.all([this.getProjectStaffList(), this.querySelects()]).then(() => {
      this.loaded = true;
      this.getKeyForModal();
    });
    this.getHandoverStaffList();
  },

  methods: {
    querySelects() {
      return ProjectManageService.getProjectSelectList().then((res) => {
        if (res.status === 'success') {
          this.projectSelects = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 获取项目组成员列表
    getProjectStaffList() {
      return ProjectManageService.getProjectStaffList(this.param).then((res) => {
        if (res.status === 'success') {
          this.tableData.dataSource = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 角色列表
    getExecroleList() {
      return ProjectManageService.getExecroleList(this.param).then((res) => {
        if (res.status === 'success') {
          this.memberData.roleList = res.data;
          this.memberDataByName.roleList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 根据角色获取组织架构
    getEmployeesTree(execrole_code) {
      const params = { execrole_code };
      return ProjectManageService.getEmployeesTree(
        Object.assign(params, this.param)
      ).then((res) => {
        if (res.status === 'success') {
          this.memberData.employeeList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    getDefaultExecroleList() {
      return ProjectManageService.getExecroleList(this.param).then((res) => {
        if (res.status === 'success') {
          if (res.data.length > 0) {
            const execroleData = [];
            res.data.forEach((item) => {
              execroleData.push({
                execrole_code: item.key,
                execrole_name: item.val,
              });
            });
            // this.memberDataByName.defaultRoleList = Array.from(new Set(this.memberDataByName.defaultRoleList));
            this.memberDataByName.defaultRoleList = execroleData;
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 根据姓名获取雇员列表
    getEmployeesExecRoleList() {
      return ProjectManageService.employeesExecRoleList(
        Object.assign(this.param)
      ).then((res) => {
        if (res.status === 'success') {
          this.memberDataByName.employeeList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 筛选的姓名
    getEmployeesTreeByName() {},

    openEditModal() {
      const arr = [];
      this.basicInfoEdit.editor_uids.forEach((item) => {
        arr.push(item.id);
      });
      this.basicInfoEdit.editor_uid = arr;
      this.modalVisible = true;
    },

    openAddMemberModal() {
      this.disableAddMember = true;
      this.getExecroleList().then(() => {
        this.memberData.visible = true;
        this.disableAddMember = false;
      });
    },
    openAddDeptModal() {
      this.deptModal = true;
      console.log(this.deptModal);
    },

    openAddMemberModalByName() {
      // this.disableAddMemberByName = true;
      Promise.all([this.getDefaultExecroleList(), this.getEmployeesExecRoleList()]).then(() => {
        this.memberDataByName.visible = true;
        this.disableAddMemberByName = false;
      });
    },

    // 根据角色添加成员
    submitAddMember(params) {
      Object.assign(params, this.param);
      console.log(params);
      ProjectManageService.addProjectStaffs(params).then((res) => {
        if (res.status === 'success') {
          this.$Message.success('添加成功');
          this.$refs.addMemberModal.init();
          this.deptModal = false;
          this.getProjectStaffList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 根据姓名添加成员
    submitAddMemberByName(params) {
      this.loading = true;
      const d = Object.assign({ staff_list: params }, this.param);
      ProjectManageService.addProjectStaffsByPerson(d).then((res) => {
        this.loading = false;
        if (res.status === 'success') {
          this.$Message.success('添加成功');
          this.$refs.addMemberModalByName.reset();
          this.getProjectStaffList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    authOperation(status) {
      if (status === '已授权') {
        return '结束授权';
      } if (status === '结束授权') {
        return '重新授权';
      }
    },

    projectStaffAuthorization({ id }) {
      const params = {
        id
        // auth_status: auth_status === '已授权' ? 2 : 1,
        // execrole_code,
      };
      ProjectManageService.projectStaffAuthorization(params).then((res) => {
        if (res.status === 'success') {
          this.getProjectStaffList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    submitEditInfo(params) {
      const currentStatus = params.project_signed_status;
      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          delete params[key];
        }
      });
      Object.assign(params, this.param);

      // 如果 未签 改为 已签，传给后端 2[签订审批中] 【没加一次project_progress_status，都要检查project_signed_status】
      if (params.project_signed_status === undefined) {
        params.project_signed_status = this.quoteBasicInfo.project_signed_status;
      }
      if (
        this.quoteBasicInfo.project_signed_status === 1
        && params.project_signed_status === 3
        && (this.quoteBasicInfo.project_progress_status === 2 || this.quoteBasicInfo.project_progress_status === 3 || this.quoteBasicInfo.project_progress_status === 9)
      ) {
        params.project_signed_status = 2;
      }
      this.submitLoading = true;

      params.begin_date = params.begin_date && params.begin_date.format('YYYY-MM-DD');
      params.end_date = params.end_date && params.end_date.format('YYYY-MM-DD');

      ProjectManageService.editProjectInfo(params).then((res) => {
        if (res.status === 'success') {
          this.modalVisible = false;
          this.$refs.newProject.$refs.form.resetFields();
          this.$refs.newProject.handleCancel();
          if (this.quoteBasicInfo.project_signed_status === 1 && currentStatus === 3) {
            this.$Message.success('编辑项目成功，项目签订审批中，可前往零氪OA审批-我的申请查看审批进展');
            setTimeout(() => {
              this.$router.push({ name: 'projectManage.projectInfoList' });
            }, 1000);
          } else {
            this.getProjectStaffList();
            this.$emit('updateBasic', 1);
          }
        } else if (res.status === 'refresh') {
          this.$Message.error(res.message);
          this.getProjectStaffList();
          this.$emit('updateBasic', 1);
        } else {
          this.$Message.error(res.message);
        }
        this.submitLoading = false;
      });
    },

    closeNewProjectModal() {
      this.modalVisible = false;
    },

    getKeyForModal() {
      const { basicInfoEdit, projectSelects } = this;
      let match = projectSelects.bidding_type_map.find(
        item => basicInfoEdit.bidding_type === item.key
      );
      basicInfoEdit.bidding_type = match ? match.key : null;
      match = projectSelects.researcher_product_map.find(
        item => basicInfoEdit.research_product === item.key
      );
      basicInfoEdit.research_product = match ? match.key : null;
      // match = projectSelects.manager_map.find(
      //   item => basicInfoEdit.manager_name === item.val,
      // );
      // basicInfoEdit.manager_uid = match ? match.key : null;
    },
    getHandoverStaffList() {
      if (!this.basicInfo.values.can_handover) {
        return;
      }
      ProjectManageService.getHandoverStaffList(this.param).then((res) => {
        if (res.status === 'success') {
          this.handoverList = res.data.handover;
          this.acceptanceList = res.data.acceptance;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    handoverStaffProcess(params) {
      ProjectManageService.handoverStaffProcess(params).then((res) => {
        if (res.status === 'success') {
          if (res.data.success) {
            this.$Message.success('交接成功');
            this.handoverForm.resetFields();
            this.handoverModalShow = false;
            this.getProjectStaffList();
            this.getProjectBasicInfo();
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    changeStaffManager(params) {
      ProjectManageService.changeStaffManager(params).then((res) => {
        if (res.status === 'success') {
          this.$Message.success('分配成功');
          this.moduleModalForm.resetFields();
          this.moduleModalShow = false;
          this.getProjectStaffList();
          // this.getProjectBasicInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    // 模块负责人交接
    handleOk() {
      this.handoverForm.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        const params = {
          ...this.param,
          ...fieldsValue
        };
        this.handoverStaffProcess(params);
      });
    },

    // 模块负责人交接
    handlemoduleModalOk() {
      this.moduleModalForm.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        const params = {
          staff_list: this.selectedRowKeys,
          ...this.param,
          ...fieldsValue
        };
        this.changeStaffManager(params);
      });
    },

    handleCancel() {
      this.handoverModalShow = false;
      this.moduleModalShow = false;
      this.handoverForm.resetFields();
    },

    handOver() {
      this.handoverModalShow = true;
    },

    // 唤起分配模块负责人弹窗
    handModuleOver() {
      if (!this.selectedRowKeys.length) {
        this.$Message.error('请先勾选被分配的人员!');
        return;
      }
      this.moduleModalShow = true;
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 删除确认框
    confirm(record) {
      this.projectStaffAuthorization(record);
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    }
  },

  watch: {
    update() {},
    quoteBasicInfo() {
      // quoteBasicInfo 引用地址改变，调用 getKeyForModal
      this.getKeyForModal();
    }
  }
};
</script>

<style lang="less">
@import "../../common.less";
.rws-erp-project-offer-info {
  .content-wrapper {
    .card {
      margin-bottom: 16px;
    }
    .add-member {
      margin-bottom: 16px;
    }
  }
}
.ant-popover-inner-content {
  .extra-content {
    margin: 0;
    padding: 0 16px;
    line-height: 32px;
    cursor: pointer;
    &:hover {
      background: rgba(16, 142, 233, 0.1);
    }
  }
}
</style>
